// extracted by mini-css-extract-plugin
export default {"list":"header-nav_list__VAiYj"};